import React from 'react';
import {graphql} from 'gatsby';
import PropTypes from 'prop-types';

import Hero from 'components/Hero.js';
import Layout from 'components/Layout.js';
import Meta from 'components/Meta.js';


export default class Page extends React.Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
    };

    render() {
        const content = this.props.data.wordpressPage;
        return (
            <Layout className="contain">
                <Meta
                    description={content.acf.subtitle}
                    title={
                        content.acf.title ? content.acf.title : content.title
                    }
                />
                <Hero
                    image={content.acf.master_image}
                    subtitle={content.acf.subtitle}
                    title={content.acf.title ?
                        content.acf.title : content.title
                    }
                />
                {content.content &&
                    <section
                        className="content"
                        dangerouslySetInnerHTML={{__html: content.content}}
                    />
                }
            </Layout>
        );
    }
}

export const query = graphql`
    query($id: Int!) {
        wordpressPage(wordpress_id: {eq: $id}) {
            acf {
                master_image
                subtitle
                title
            }
            content
            title
        }
    }
`;
